// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/app_settings/products_data" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appSettingsProductsData } from "./constants";
import type { AppSettingsProductsDataParams, AppSettingsProductsDataResult } from "./types";

export const getDataTableAppSettingsProductsData = reactQueryTableFetcherAdapter(
  appSettingsProductsData,
  (
    signal: AbortSignal,
    { appGroupId, query, groupby, limit = 20, start = 0, sortdir, sortby }: AppSettingsProductsDataParams
  ): Promise<AppSettingsProductsDataResult> => {
    return fetch(
      "/app_settings/products_data",
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        query: serializeQueryObjects(query),
      },
      { signal }
    );
  }
);
